<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-header(
                v-show='!gameFinished && gameStarted'
                :time='getTime'
                :slug="type"
                :gameType="parameters.courseType"
                :is-homework="!!exerciseId"
            )
            game-preparation-counter(v-if='!gameStarted && isRunning && counter', :counter="counter")
            template(v-else="")
                .play-box__game( v-if='gameStarted && !gameFinished || !gameStarted && !gameFinished && !isRunning')
                    .play-box__example
                        .play-box__header(v-if='isRunning && gameStarted && !gameFinished && showAnagram')
                            .play-box__word.play-box__subtitle(
                                :style="'font-size:' + fontSize + 'px; line-height:' + (+fontSize + 3) + 'px'"
                            )
                                | {{ currentItem }}
                        scaling-bar(
                            v-if="!isRunning && parameters.withTime && !gameStarted || !parameters.withTime && isRunning"
                            @doneWithPreparing="doneWithPreparing"
                            @setFontSize="setFontSize"
                            :is-game-tuned="isRunning"
                            :font-size="fontSize"
                            element-name="play-box__header"
                            :is-from-shutter="false"
                            :is-item-column-mode="true"
                            :amount-of-words="1"
                        )
                        .play-box__field(v-if='isRunning && gameStarted && !gameFinished ')
                            .play-box__answer-container(v-if="showAnswerForm")
                                .answer-container__header {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheAnswer') }}
                                .answer-container__input
                                    cs-input(
                                        ref='input',
                                        @keyup.native.enter='processReply',
                                        v-model='answer'
                                    )
                                .play-box__buttons
                                    cs-button.play-box__button(@click='processReply', color="blue")
                                        | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                                    cs-button.play-box__button(
                                        v-if='!isOlympiad',
                                        @click='showCorrectAnswer',
                                        color="blue"
                                    )
                                        | {{ $i18n.t('trainer.trainer_gamePlayBox_unknownAnswer') }}
                        .play-box__end-container(v-else-if='gameStarted && !gameFinished')
                            .play-box__reaction-container
                                .play-box__answers-container(v-if="isCorrectAnswerShown")
                                    .play-box__answers.play-box__answers--bad
                                        | {{ anagram }}
                                    .play-box__answers.play-box__answers--good(:class="{'play-box__answers_width_cut': correctAnswers[0].length > 5}")
                                        | {{ humanReadableCorrectAnswers }}
                                .play-box__answers.play-box__answers--bad.play-box__answers--show-md(v-if="isCorrectAnswerShown")
                                    | {{ anagram }}
                                result-image.play-box__image(:status="correct ? 'success' : 'failure'")
                                .play-box__answers.play-box__answers--good.play-box__answers--show-md.play-box__answers_width_cut(v-if="isCorrectAnswerShown")
                                    | {{ humanReadableCorrectAnswers }}
                            .play-box__buttons(v-if='!gameFinished')
                                cs-button.play-box__button(
                                    v-if='isCorrectAnswerShown',
                                    v-focus='',
                                    @click='refreshGame'
                                    color="blue"
                                    pattern="primary-outline"
                                )
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                                cs-button.play-box__button(
                                    v-else-if='!correct && !halfcorrect',
                                    v-focus='',
                                    @click='refreshGame'
                                    color="blue"
                                    pattern="primary-outline"
                                )
                                    | {{ $i18n.t('trainer.trainer_games_tryAgain') }}
                                template(v-else="")
                                    cs-button.play-box__button(
                                        v-if='halfcorrect',
                                        v-focus='',
                                        @click='refreshGame'
                                        color="blue"
                                        pattern="primary-outline"
                                    )
                                        | {{ $i18n.t('trainer.trainer_games_collectWordAgain') }}
                                    cs-button.play-box__button(
                                        v-else='',
                                        v-focus='',
                                        @click='refreshGame'
                                        color="blue"
                                        pattern="primary-outline"
                                    )
                                        | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                    game-info.play-box__game-info(
                        :score="{left: answers.good, right: answers.bad}"
                        :time="getTime"
                        :is-olympiad="isOlympiad"
                    )
            .play-box__end-container(v-if='gameFinished && !isOlympiad')
                fireworks(:is-mobile="isMobile")
                .play-box__reaction-container
                    .play-box__answers-container
                        .play-box__answers.play-box__answers--good
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                            br
                            | {{ answers.good }}
                        .play-box__answers.play-box__answers--bad
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                            br
                            | {{ answers.bad }}
                    .play-box__answers.play-box__answers--good.play-box__answers--show-md
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                        br
                        | {{ answers.good }}
                    result-image.play-box__image(status="success")
                    .play-box__answers.play-box__answers--bad.play-box__answers--show-md
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                        br
                        | {{ answers.bad }}
                result-buttons(
                    :exercise-id="exerciseId"
                    :gamesType="parameters.courseType"
                    show-restart-button
                    @restartGame="restartGame"
                )
                    slot
        cs-loader(v-else='')
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import AnagramsApi from '../../../../api/games/anagrams';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import ScalingBar from './ScalingBar.vue'
    import MobileDetect from "mobile-detect";
    import GamePreparationCounter from '../../GamePreparationCounter.vue'
    import GameInfo from '../GameInfo.vue'

    const MAX_WORD_LENGTH = 10;
    const MAX_SPAN_WIDTH = 1000;
    const MAX_SPAN_HEIGHT = 212;

    function DEFAULT_DATA () {
        return {
            showTurtle: true,
            isRunning: false,
            words: [],
            answer: '',
            anagram: '',
            fontSize: 18,
            correctAnswers: null,
            correct: false,
            halfcorrect: false,
            showAnagram: true,
            isSingleScreen: true,
            isCorrectAnswerShown: false,
            showAnswerForm: false,
            isFocused: false,
            isMobile: false,
            answers: {
                good: 0,
                bad: 0,
            },
            lastAnswer: {
                good: 0,
                bad: 0,
            },
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        components: {
            GameInfo,
            GamePreparationCounter,
            ScalingBar,
        },
        data () {
            return DEFAULT_DATA();
        },
        mounted () {
            this.isMobile = Boolean((new MobileDetect(window.navigator.userAgent)).phone());
        },
        computed: {
            currentItem () {
                this.correctAnswers = this.words[0].answers.map(answer => {
                    return answer.word.toLowerCase();
                });
                this.anagram = this.makeAnagram(this.words[0].word);
                return this.anagram;
            },
            humanReadableCorrectAnswers () {
                return this.correctAnswers.reduce((result, answer) => {
                    result += (result ? `,\n\r` : '') + answer
                    return result
                }, '')
            }
        },
        watch: {
            isRunning: {
                handler (val) {
                    this.$emit('checkAnswersReady', val);
                },
                immediate: true
            },
        },
        updated() {
            if (!this.isFocused && this.$refs.input) {
                this.$refs.input.$el.focus();
                this.isFocused = true;
            }
        },
        methods: {
            fetchData() {
                this.getExercise()
                .then(() => {
                    AnagramsApi.getWords({
                        locale: this.user.locale,
                        groups: this.parameters.selectedGroups,
                        lengths: this.parameters.letters,
                        limit: this.parameters.amountOfWords - this.answers.good
                    })
                    .then(data => {
                        this.words = Object.values(data).map(word => {
                            word.word = word.word.replace('&#x301;', '');
                            return word;
                        });
                        if (!this.parameters.withTime) {
                            this.isRunning = true;
                            this.registerSounds();
                        }  else {
                            this.isLoading = false;
                        }
                    })
                    .catch(err => this.showErrorMessage(err));
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
            },
            beforeStart () {
                this.gameStarted = true;
                this.$nextTick(() => {
                    this.startGame();
                });
            },
            startGame () {
                this.setTimer();
                if (this.parameters.withTime) {
                    setTimeout(() => {
                        this.showAnagram = false;
                        this.showAnswerForm = true;
                        this.answerDuration && this.startAnswerTimer();
                    }, this.parameters.showTime * 1000)
                } else {
                    this.showAnswerForm = true;
                    this.answerDuration && this.startAnswerTimer();
                }
            },
            processReply () {
                if (this.answer !== '') {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.halfcorrect = this.checkHalfCorrectAnswer()
                    if (this.halfcorrect) {
                        this.correct = this.correctAnswers.some(correctAnswer => {
                            return this.answer === correctAnswer;
                        });
                        if (this.correct) {
                            this.halfcorrect = false;
                            this.answers.good++;
                            this.lastAnswer.good++;
                            this.words.shift();
                            this.playResultSound('success');
                        }
                    } else {
                        this.playResultSound('failure');
                        this.answers.bad++;
                        this.lastAnswer.bad++;
                        if (this.isOlympiad) {
                            this.words.shift();
                        }
                    }
                    if (this.isOlympiad && this.answers.good + this.answers.bad >= this.parameters.amountOfWords) {
                        this.gameFinished = true;
                    }
                    this.isRunning = false;
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    if (this.isOlympiad) {
                        this.refreshGame();
                    }
                    if (!this.words.length) {
                        this.finishGame();
                    }
                } else if (this.isOlympiad) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.answers.bad++;
                    this.words.shift();
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.refreshGame();
                    if (!this.words.length) {
                        this.finishGame();
                    }
                }
            },
            showCorrectAnswer () {
                this.answer = '1';
                this.isCorrectAnswerShown = true;
                AnagramsApi.getWords({
                    locale: this.user.locale,
                    groups: this.parameters.selectedGroups,
                    lengths: this.parameters.letters,
                    limit: 1
                })
                .then(data => {
                    let newWord = Object.values(data).map(word => {
                        word.word = word.word.replace('&#x301;', '');
                        return word;
                    })[0];
                    this.words.push(newWord);
                })
                .catch(err => this.showErrorMessage(err));
                this.processReply();
            },
            checkHalfCorrectAnswer() {
                this.answer = this.answer.toLowerCase().trim();
                return this.correctAnswers[0].length === this.answer.length
                        && _.difference(this.correctAnswers[0].split(''), this.answer.split('')).length === 0;
            },
            refreshGame () {
                this.setTimer();
                if (this.isCorrectAnswerShown) {
                    this.isCorrectAnswerShown = false;
                    this.words.shift();
                }
                this.isFocused = false;
                this.correct = null;
                this.answer = '';
                this.isRunning = true;
                if (this.lastAnswer.good === 1) {
                    this.lastAnswer.good = 0;
                    this.lastAnswer.bad = 0;
                }
                if (this.parameters.withTime) {
                    this.showAnagram = true;
                    this.showAnswerForm = false;
                    setTimeout(() => {
                        this.showAnagram = false;
                        this.showAnswerForm = true;
                        this.answerDuration && this.startAnswerTimer();
                    }, this.parameters.showTime * 1000)
                } else if (this.answerDuration) {
                    this.startAnswerTimer();
                }
            },
            finishGame () {
                this.gameFinished = true;
                this.stopTimer();
            },
            makeAnagram (word) {
                let newWord = word.split('').sort(() => 0.5 - Math.random()).join('');
                const needsRepeat = this.correctAnswers.some(answer => {return answer === newWord})
                return needsRepeat ? this.makeAnagram(word) : newWord;
            },
            playResultSound(result) {
                if (!this.isOlympiad) {
                    this.resultInstance = this.$createjs.Sound.play(result);
                    this.resultInstance.volume = 0.6;
                }
            },
            refreshGameStatBeforeSend () {
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.lastAnswer = this.lastAnswer;
                this.gameStat.answers = this.answers.good;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt(this.answers.good / (total) * 100);
                }
                return 0;
            },
            setFontSize (fontSize) {
                this.fontSize = fontSize;
            },
            doneWithPreparing () {
                if (this.parameters.withTime) {
                    this.isRunning = true;
                    this.isLoading = true;
                    this.registerSounds();
                }
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 280px;
        @include media($sm) {
            max-width: 330px;
        }
    }

    .play-box__word {
        padding: 10px;
        margin: 0 10px 10px 0;
        background: $x-color-white;
        border-radius: $border-radius-5;
        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 20px;
        @include media($sm) {
            margin-bottom: 30px;
        }
        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }
    }

    .play-box__title {
        margin-bottom: 20px;
    }

    .play-box__subtitle {
        margin-bottom: 0;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--good {
        color: $hsl-color-green-58;
        @include media($md) {
            margin-left: 20px;
        }
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--bad {
        color: $hsl-color-red-62;
        @include media($md) {
            margin-right: 20px;
        }
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: none;
        @include media($md) {
            display: block;
        }
    }

    .play-box__answers_width_cut {
        width: min-content;
    }

    .play-box__answers-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        @include media($md) {
            display: none;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
